import { redirect } from "react-router-dom";
import { AbsoluteCenter, Box, Heading, Stack, Text, Link } from "@chakra-ui/react";

import { RoutesMap } from "../../routes.tsx";
import { VITE_USER_AGREEMENT_URL } from "../../ENV";
import { EJWTStatus, validateJWT } from "../../utils";
import { PhoneNumberForm } from "../../components/features/LoginPage";
import { isActiveToken } from "../../utils/session/authorizationToken";
import { usePersistStore } from "../../store/persistStore";
import { useLoginFormStore } from "../../store/loginFormStore";
import { EPhoneFormState } from "../../store/slices/phoneFormSliceCreator";
import { isNewAuthorization, useAuthorizationStore } from "../../store/authorizationStore";

export function LoginPage() {
  return (
    <Box position="relative" h="calc(100vh - 84px * 2)">
      <AbsoluteCenter axis="both">
        <Stack spacing={9} minW="300px" pb="100px">
          <div><Heading textAlign="center">Вход в кабинет</Heading></div>

          <PhoneNumberForm />
          <Text align="center">
            Продолжая я соглашаюсь с&nbsp;
            <Link
              textDecoration="underline"
              color="gray.600"
              _hover={{ color: "brand.500" }}
              href={VITE_USER_AGREEMENT_URL}
            >
              пользовательским соглашением
            </Link>
          </Text>
        </Stack>
      </AbsoluteCenter>
    </Box>
  );
}

LoginPage.loader = () => {
  if (isNewAuthorization()) {
    const auth = useAuthorizationStore.getState();

    if (auth.restoringPin) {
      useLoginFormStore.getState().setPhoneFormState(EPhoneFormState.initial);
      return null;
    }

    if (isActiveToken(auth.token)) {
      return redirect("/");
    }

    if (auth.deviceId) {
      return redirect(RoutesMap.login.pin);
    }

    useLoginFormStore.getState().setPhoneFormState(EPhoneFormState.initial);
    return null;
  }

  const state = useLoginFormStore.getState();
  const { deviceJWT } = usePersistStore.getState();
  const deviceJwtState = validateJWT(deviceJWT);

  switch (deviceJwtState) {
    case EJWTStatus.Valid: {
      return redirect("/");
    }
    case EJWTStatus.Expired:
    case EJWTStatus.RefreshRequired: {
      return redirect(RoutesMap.login.pin);
    }
  }

  state.setPhoneFormState(EPhoneFormState.initial);
  return null;
};
